import React from 'react';
import { Link } from 'react-router-dom';
import { LuArrowUpRight, LuLayers } from 'react-icons/lu';
import { LOGO_NAV_URL } from '../../brand/logo';
import { QNAREAD } from '../../config/appLabels';
import './auth.css';

export default function AuthShell({
  title,
  subtitle,
  children,
  footer,
}) {
  return (
    <div className="auth-page">
      <header className="auth-topbar">
        <Link to="/product" className="auth-brand">
          <img src={LOGO_NAV_URL} alt="QnaRead logo" width={32} height={32} />
          <span>QnaRead</span>
        </Link>
        <nav className="auth-topbar-nav" aria-label="Explore product">
          <Link
            to="/product"
            className="auth-topbar-product"
            title="Stats, feedback, and full product tour"
          >
            <LuLayers className="auth-topbar-product-icon" aria-hidden />
            <span>Product</span>
            <LuArrowUpRight className="auth-topbar-product-arrow" aria-hidden />
          </Link>
        </nav>
      </header>

      <main className="auth-main">
        <div className="auth-layout">
          <aside className="auth-aside" aria-hidden="false">
            <p className="auth-aside-eyebrow">Sign in to your workspace</p>
            <h1>{QNAREAD.tagline}</h1>
            <p className="auth-aside-lead">
              Sign in to import PDFs, build notebooks, search your library, and review on Study hub — separate from our public marketing pages.
            </p>
            <ol className="auth-steps">
              <li>
                <span className="auth-step-num">1</span>
                <span>Sign in or create an account</span>
              </li>
              <li>
                <span className="auth-step-num">2</span>
                <span>Quick onboarding (goals & topics)</span>
              </li>
              <li>
                <span className="auth-step-num">3</span>
                <span>Study hub — progress, save, practice, review</span>
              </li>
            </ol>
          </aside>

          <div className="auth-card">
            {title && <h2>{title}</h2>}
            {subtitle && <p className="auth-card-sub">{subtitle}</p>}
            {children}
            {footer}
            <p className="auth-trust">
              Encrypted sessions · optional MFA ·{' '}
              <Link to="/security" style={{ color: '#64748b' }}>Security</Link>
            </p>
          </div>
        </div>
      </main>

      <footer className="auth-page-footer">
        © {new Date().getFullYear()} QnaRead · Not the public marketing homepage
      </footer>
    </div>
  );
}
